import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const ThankYou = () => {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    // Google Ads Conversion Event
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-18049237016/zUOsCOG8lpIcEJiAxp5D'
      });
    }

  }, []);

  return (
    <>
      <Helmet>
        <title>Thank You - ANS Safety Nets</title>
        <meta
          name="description"
          content="Thank you for contacting ANS Safety Nets. We will get back to you shortly."
        />
      </Helmet>
      <div className="min-h-screen flex items-center justify-center bg-[#2c3639] p-6">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center space-y-6">
          <h1 className="text-4xl font-bold text-[#2c3639] md:text-5xl">
            Thank You!
          </h1>
          <p className="text-lg text-gray-700 md:text-xl">
            Your message has been sent successfully. We'll get back to you soon.
          </p>
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-[#a27b5c] text-white font-semibold rounded-md hover:bg-[#8c674b] transition-colors duration-200 focus:ring-2 focus:ring-[#a27b5c] focus:ring-offset-2"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default ThankYou;